/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_FemaleInputs */

const en_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`female`)
};

const fr_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`feminin`)
};

const de_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weiblich`)
};

const it_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`femmina`)
};

const ru_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`женский`)
};

const es_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`femenino`)
};

const zh_cn2_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性`)
};

const ja_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性`)
};

const hi_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`महिला`)
};

const pt_pt2_voice_manager_gender_female = /** @type {(inputs: Voice_Manager_Gender_FemaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fêmea`)
};

/**
* | output |
* | --- |
* | "female" |
*
* @param {Voice_Manager_Gender_FemaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_female = /** @type {((inputs?: Voice_Manager_Gender_FemaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_FemaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_gender_female(inputs)
	if (locale === "de") return de_voice_manager_gender_female(inputs)
	if (locale === "it") return it_voice_manager_gender_female(inputs)
	if (locale === "ru") return ru_voice_manager_gender_female(inputs)
	if (locale === "es") return es_voice_manager_gender_female(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_gender_female(inputs)
	if (locale === "ja") return ja_voice_manager_gender_female(inputs)
	if (locale === "hi") return hi_voice_manager_gender_female(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_gender_female(inputs)
	return en_voice_manager_gender_female(inputs)
});